import React, { useEffect, useState } from "react";
import GlobalGridMap from "./GlobalGridMap";
import styles from "./GlobalGridMap.module.css";
import { getNetworkData } from "../../utils/networkDataCache";
import { useHistory, useLocation } from "react-router-dom";
import { FREEIPAPI_URL } from "../Constants";

const REGIONS = [
  { name: "india", lat: 20.5937, lon: 78.9629 },
  { name: "europe", lat: 54.526, lon: 15.2551 },
  { name: "china", lat: 35.8617, lon: 104.1954 },
  { name: "australia", lat: -25.2744, lon: 133.7751 },
  { name: "united_states", lat: 37.0902, lon: -95.7129 },
];

export default function GlobalGrid() {
  const [networkData, setNetworkData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkingLocation, setCheckingLocation] = useState(true);
  const history = useHistory();
  const location = useLocation();

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

useEffect(() => {
    const initPage = async () => {
      setLoading(true);
      const params = new URLSearchParams(location.search);

      if (!params.get("region")) {
        try {
          const response = await fetch(FREEIPAPI_URL);
          if (!response.ok) throw new Error("Location service unavailable");

          const geo = await response.json();

          if (geo && geo.latitude !== undefined && geo.longitude !== undefined) {
            let nearest = REGIONS[0];
            let minDistance = Infinity;

            REGIONS.forEach((region) => {
              const dist = calculateDistance(
                geo.latitude, 
                geo.longitude, 
                region.lat, 
                region.lon
              );
              if (dist < minDistance) {
                minDistance = dist;
                nearest = region;
              }
            });

            history.replace({
              pathname: location.pathname,
              search: `?region=${nearest.name}`,
            });
          } else {
            throw new Error("Invalid API response");
          }
        } catch (err) {
          console.error("Geo-detection failed, defaulting to United States:", err);
          history.replace({
            pathname: location.pathname,
            search: "?region=united_states",
          });
        } finally {
          setCheckingLocation(false);
        }
      } else {
        setCheckingLocation(false);
      }

      try {
        const data = await getNetworkData();
        setNetworkData(data);
        setLoading(false);
      } catch (err) {
        console.warn("Network data failed, retrying...");
        setTimeout(() => {
            if (loading) initPage();
        }, 5000);
      }
    };

    initPage();
  }, [location.pathname]);
  const goBackToHomePage = () => {
    history.push("/");
  };

  return (
    <>
      <button className={styles.goBackButton} onClick={goBackToHomePage}>
        Go back to home page
      </button>
      <div className={styles.globalGridPage}>
        {checkingLocation ? (
          <div className={styles.mapContainer}>
            <div className={styles.loaderContainer}>
              <div className={styles.loader}></div>
            </div>
          </div>
        ) : (
          <GlobalGridMap networkData={networkData} loading={loading} />
        )}
      </div>
    </>
  );
}
